import { Component, Input, OnInit } from '@angular/core';
import { EmopPublicWorkflowCreateService } from '../../emop-public-workflow-create.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { EmopPublicUsercenterSelectorComponent } from '../../../../public-components/emop-public-usercenter-selector/emop-public-usercenter-selector.component';
@Component({
  selector: 'app-emop-public-workflow-create-appointee',
  templateUrl: './emop-public-workflow-create-appointee.component.html',
  styleUrls: ['./emop-public-workflow-create-appointee.component.scss']
})
export class EmopPublicWorkflowCreateAppointeeComponent implements OnInit {
  userSelectorVisible: boolean = false;
  editItem; // 当前编辑的流程节点
  checkedIds = [];
  constructor(
    public EmopPublicWorkflowCreateService: EmopPublicWorkflowCreateService,
    private modal: NzModalService
  ) { }

  ngOnInit(): void {
  }
  /**
   * 选择用户
   * @param item
   */
  selecteUser(item) {
    this.editItem = item;
    this.checkedIds = item.currentUser.map(item => item.id);
    this.userSelectorVisible = true;
  }
  /**
   * 选择用户
   * @param rs 
   */
  submit(rs) {
    if (rs) {
      rs.data = JSON.parse(JSON.stringify(rs.data));
      rs.data.forEach(item => { item.allowDelete = true; item.identity = item.id; });
      if (rs.type === 'save') {
        const defaultUser = this.editItem.currentUser.filter(item => !item.allowDelete);
        this.editItem.currentUser = [...defaultUser, ...rs.data];
      } else {
        // 去重
        const currentIds = this.editItem.currentUser.map(item => item.id);
        rs.data = rs.data.filter(item => !currentIds.includes(item.id));
        this.editItem.currentUser = [...this.editItem.currentUser, ...rs.data];
      }
      this.userSelectorVisible = false;
    }
  }
  /**
   * 移除用户
   */
  removeUser(item, user) {
    item.currentUser = item.currentUser.filter(p => p !== user);
  }
}
